import React from 'react';
import Icon from './ui/Icon';
import Reveal from './ui/Reveal';
import { originQuote } from '../data/content';

/**
 * The dark band between the hero and "Why TEEEM?": the founding question, and
 * the two lines the brief uses to turn it into the ministry's name.
 */
export default function OriginQuote() {
  return (
    <section className="on-dark grain relative bg-ink-900 py-20 sm:py-24">
      <div className="shell relative max-w-4xl">
        <Reveal className="flex gap-6 sm:gap-8">
          <Icon name="quote" className="mt-2 h-8 w-8 shrink-0 text-gold/60 sm:h-10 sm:w-10" />
          <blockquote className="font-serif text-xl font-light leading-relaxed text-cream/90 sm:text-[1.6rem] sm:leading-[1.55]">
            {originQuote.lead}
            <em className="not-italic text-gold">{originQuote.emphasis}</em>
            {originQuote.trail}
          </blockquote>
        </Reveal>

        <Reveal variant="rule" delay={200} className="mt-10 h-px w-full bg-cream/10" />

        <div className="mt-10 sm:pl-[3.5rem]">
          <Reveal as="p" className="font-display text-lg uppercase tracking-[0.06em] text-cream sm:text-xl">
            {originQuote.becameVision}
          </Reveal>
          <Reveal as="p" delay={120} className="mt-4 max-w-2xl text-[0.98rem] leading-relaxed text-cream/70">
            {originQuote.vision}
          </Reveal>
          <Reveal
            as="p"
            delay={240}
            className="mt-6 font-display text-xl font-semibold uppercase tracking-[0.06em] text-gold sm:text-2xl"
          >
            {originQuote.becameTeeem}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
